import { Icon } from 'shared/iconpack'
import { ParamKey } from 'shared/types/QueryModel'

import { Button } from 'shared/ui/Button'
import { Spin } from 'shared/ui/Spin'

import { palette } from 'shared/config/styles/palette'

import { useDownloadTable } from '../hooks/useDownloadTable'

interface Props {
  apiUrl: string
  params: ParamKey[]
}
const DownloadTableButton = ({ apiUrl, params }: Props) => {
  const { handleDownloadTable, isLoading } = useDownloadTable({ params })

  return (
    <Button
      disabled={isLoading}
      className={`w-[44px] h-[36px] py-[8px] px-[12px] ${isLoading ? '!bg-light_gray_18' : '!bg-dark_blue_1'} rounded-[12px]`}
      onClick={() => handleDownloadTable(apiUrl)}
    >
      {isLoading ? (
        <Spin size="small" />
      ) : (
        <Icon
          name="download"
          width={18}
          height={20}
          color={palette.white}
        />
      )}
    </Button>
  )
}

export default DownloadTableButton
